import styled from "styled-components";
import { COLORS } from "../../../../../../layout/theme";
import { Select } from "antd";

export const TableContainer = styled.div`
	.ant-table-thead > tr > th {
		background: ${COLORS.Primary};
	}

	.ant-table-thead
		> tr
		> th:not(:last-child):not(.ant-table-selection-column):not(
			.ant-table-row-expand-icon-cell
		):not([colspan])::before {
		background-color: ${COLORS.White};

		div {
			color: ${COLORS.White};
		}
	}

	thead {
		border-color: ${COLORS.White};
		border: 1px solid ${COLORS.White};
	}
`;

export const Container = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const AntdSelectContainer = styled.div`
	.ant-select-single.ant-select-show-arrow .ant-select-selection-item {
		color: ${(props) =>
			props.conditionColor ? COLORS.Danger : COLORS.MediumGrey};
	}
`;
